// extracted by mini-css-extract-plugin
export default {"drawer":"DeckDrawer_drawer__c+s9r"};